import React, { useContext } from 'react';
import FooterNav from './FooterNav';
import { ProductContext } from '../../context/AppContext';

function Footer() {
  const { Translate } = useContext(ProductContext);

  return (
    <FooterNav authToken={localStorage.getItem("AuthToken")} translate={Translate} />
  );
}

export default Footer
